var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left_footer"},[_c('span',{staticClass:"title"},[_vm._v("月度销量统计")]),_c('div',{style:({ width: '100%', height: '100%' }),attrs:{"id":"myChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }